import { gql } from 'apollo-boost';

export const GET_AVAILABLE_CHAT_MODELS = gql`
    query {
        getAvailableChatModels {
            model
            provider
            providerLabel
            displayName
            description
            tier
            minCredits
            isPreview
            supportsStreaming
            supportsWebSearch
            reasoningEfforts
        }
    }
`;
